module.exports = __webpack_public_path__ + "img/LK.23e5cb5f.svg";